import ReactMarkdown from "react-markdown";
import { StyledCard, StyledCardTxtContent } from "../styles/styledComponents";
import noImage from "../assets/images/noImg.jpg";

type CardProps = {
  imgUrl: string;
  title: string;
  text: string;
};

const Card = (props: CardProps) => {
  const { title, imgUrl, text } = props;

  return (
    <StyledCard>
      <img
        src={
          imgUrl !== ""
            ? require("../assets/images/products/" + imgUrl)
            : noImage
        }
        alt=""
      />
      <StyledCardTxtContent>
        <h3>{title.toUpperCase()}</h3>
        <ReactMarkdown
          components={{
            a: ({ node, ...props }) => (
              <a {...props} target="_blank" rel="noopener noreferrer" />
            ),
          }}
        >
          {text}
        </ReactMarkdown>
      </StyledCardTxtContent>
    </StyledCard>
  );
};

export default Card;
